import axios from "axios";
import { useConfigQuery } from "../../queries/useConfig";

async function gerarTransacao(idLoja) {
  const accessToken = window?.localStorage?.getItem("accessToken"); // lê sempre o mais recente
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    //  timeout: 15000, 
  };

  const url = `https://techfood-api.herokuapp.com/v1/restaurantes/${encodeURIComponent(idLoja)}/produtos/geraTransacao`;
  const response = await axios.get(url, options);
  return response.data; // normalmente você quer só o payload
}

async function getTransacaoById(transactionId, idLoja) {
  const accessToken = window?.localStorage?.getItem("accessToken"); // lê sempre o mais recente
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    //  timeout: 15000, 
  };

  const url = `https://techfood-api.herokuapp.com/v1/restaurantes/${idLoja}/produtos/transacao/${transactionId}`;
  console.log(url);
  const response = await axios.get(url, options);
  console.log(response.data);
  return response; 
}


async function cancelarTransacaoPendente(idLoja) {
  const accessToken = window?.localStorage?.getItem("accessToken");
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    //  timeout: 15000, 
  };
  const url = `https://techfood-api.herokuapp.com/v1/restaurantes/${idLoja}/produtos/finalizarTransacoes`;
  return axios.get(url, options);
}

export { gerarTransacao, getTransacaoById, cancelarTransacaoPendente };
